//yfret_code_version 3.9

var TTUtils = function()
{
    this.prev_tt_sid = null
    this.validateEmail = function(user_id)
    {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(user_id);
    }

    this.createXMLHTTPObject = function()
    {
    var XMLHttpFactories = [
        function () {return new XMLHttpRequest()},
        function () {return new ActiveXObject("Msxml2.XMLHTTP")},
        function () {return new ActiveXObject("Msxml3.XMLHTTP")},
        function () {return new ActiveXObject("Microsoft.XMLHTTP")}
    ];

    var xmlhttp = false;
    for (var i=0; i<XMLHttpFactories.length; i++)
    {
        try
        {
        xmlhttp = XMLHttpFactories[i]();
        }
        catch (e)
        {
        continue;
        }
        break;
    }
    return xmlhttp;
    }

    this.get_tt_sid = function(recycle)
    {
        var tt_sid = Math.random().toString();
        var tt_sid_persistant = window.localStorage.getItem('tt_sid')
        var tt_sid_epoch = window.localStorage.getItem('tt_sid_epoch')
        if(tt_sid_epoch){
            //if new sessions starts within 30 mins pass prev_sid in event
            tt_sid_expired = ((new Date() - new Date(parseInt(tt_sid_epoch))) / 60000) > 30
            if(!tt_sid_expired){
                this.prev_tt_sid = tt_sid_persistant
            }

            //handling the 'open in new tab' problem
            if(recycle && (document.referrer.indexOf(window.location.hostname) != -1) && tt_sid_persistant){
                tt_sid = tt_sid_persistant
            }
        }
        window.localStorage.setItem('prev_tt_sid', tt_sid_persistant)
        window.localStorage.setItem('tt_sid', tt_sid)
        this.setCookie('tt_sid', tt_sid, 365)
        return tt_sid
    }

    this.getFromLocalStorage = function(object_key, default_value)
    {
    default_value = this.validateArgument(default_value,null);

    if(object_key in window.localStorage)
    {
        if(typeof(window.localStorage[object_key]) != "undefined")
        {
        try
        {
            return JSON.parse(window.localStorage[object_key]);
        }
        catch(Exception)
        {
            return window.localStorage[object_key];
        }
        }
        
    }
    else
    {
        return default_value;
    }
    }

    this.validateArgument = function(param, default_value)
    {
    return typeof(param) === "undefined" ? default_value : param;
    }

    this.post = function(params, async, isIE)
    {
    var url = 'http://track.yfret.com/event/';
    var event_id = '';
    var tt_sid = '';

    params["api_version"] = "1.1.0";

    if(Storage)
    {
        if('event_id' in window.sessionStorage)
        {
        event_id = window.sessionStorage['event_id'];
        }
        else
        {
        event_id = this.checkCookie('tt_event_id');
        if (event_id == null)
        {
            event_id = '';
        }
        }

        tt_sid = window.sessionStorage.getItem('tt_sid') || this.getParameterByName('yfret_tt_sid')
        tt_sid_epoch = window.localStorage.getItem('tt_sid_epoch')
        if(tt_sid){
            if(tt_sid_epoch){
                //expiry time is 30 minutes
                tt_sid_expired = ((new Date() - new Date(parseInt(tt_sid_epoch))) / 60000) > 30
                if(tt_sid_expired){
                    tt_sid = this.get_tt_sid(false) 
                    window.sessionStorage.setItem('tt_sid', tt_sid);
                }
            }
        }
        else
        {
            tt_sid = this.get_tt_sid(true);
            if(this.prev_tt_sid){
                params['prev_sid'] = this.prev_tt_sid
                this.prev_tt_sid = null 
            }
            window.sessionStorage.setItem('tt_sid', tt_sid);
        }
        window.localStorage.setItem('tt_sid_epoch', new Date().getTime())


        if (this.getFromClientStorage("cem.subscriptionId"))
        {
        params["browser_endpoint"] = this.getFromClientStorage("cem.subscriptionId");
        }
    }

    if(event_id != null)
    {
        params['event_id'] = event_id;
    }
    if(tt_sid != null)
    {
        params['sid'] = tt_sid;
    }

    var now = new Date();
    var when = now.getTime();
    var tz = now.getTimezoneOffset();
    tz = tz.toString();
    params['tz'] = tz;

    var tt_id = this.checkCookie('tid');
    if(tt_id == null)
    {
        tt_id = when.toString();
	params['new_user'] = 1
        this.setCookie('tid',tt_id,365)
    }
    params['tt_id'] = tt_id;

    var tt_id = '';
    if('tt_id' in window.localStorage)
    {
        params['tt_id'] = window.localStorage['tt_id'];
        this.setCookie('tid', window.localStorage['tt_id'], 365)
    }
    else
    {
        tt_id = this.checkCookie('tid');
        if(tt_id == null)
        {
        tt_id = when.toString();
        window.localStorage['tt_id'] = tt_id;
        this.setCookie('tid',tt_id,365)
        }
        else
        {
        window.localStorage['tt_id'] = tt_id;
        this.setCookie('tid',tt_id,365)
        }
        params['tt_id'] = tt_id;
    }

    var protocol = window.location.protocol;
    for(key in params)
    {
        if(typeof(params[key]) === "object")
        {
        try
        {
            params[key] = encodeURIComponent(JSON.stringify(params[key]));
        }
        catch(error)
        {
            console.warn("[CEM ERROR] " + error.message);
            continue;
        }
        }
    }
    var req = null;
    if(isIE)
    {
        if(window.XDomainRequest)
        {
        req = new XDomainRequest();
        }
    }
    else
    {
        req = this.createXMLHTTPObject();
    }

    var meta_tags = this.pickUpOGTags();
    for(var attr in meta_tags)
    {
        params[attr] = meta_tags[attr];
    }

    var url_get = protocol + '//track.yfret.com/event/?when=' + when;
    for(param in params)
    {
        url_get += '&' + param + '=' + params[param];
    }
    var self = this;
    if(req != null || req != 'undefined')
    {
        req.open('GET',url_get,async);
        req.onload = function(e) {
        var arraybuffer = req.response;
        var response = JSON.parse(arraybuffer);
        if('id' in response)
        {
            if(Storage)
            {
            window.sessionStorage['event_id'] = response['id'];
            self.setCookie('tt_event_id',response['id']);
            }
        }
        };

        req.send();
    }
    }

    this.getCookie = function(name)
    {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    
    for(var i=0;i < ca.length;i++)
    {
            var c = ca[i];
            while (c.charAt(0)==' ')
        {
        c = c.substring(1,c.length);
            }
            if (c.indexOf(nameEQ) == 0)
        {
        return c.substring(nameEQ.length,c.length);
            }
    }
    return null;
    }

    this.pickUpOGTags = function()
    {
    var array_meta_tags = document.getElementsByTagName('meta');
    var og_data = {};
    for (var idx_meta = 0; idx_meta < array_meta_tags.length; idx_meta++)
    {
        var property = array_meta_tags[idx_meta].getAttribute('property');
        var content = array_meta_tags[idx_meta].getAttribute('content');
        if((property == 'og:title' || property == 'og:image') && content != null)
        {
        og_data[property] = content;
        }
    }
    og_data['og:url'] = encodeURIComponent(window.location.href);
    return og_data;
    }

    this.setCookie = function(c_name,value,exdays)
    {
    var exdate=new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value=escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
    c_value += "; path=/";
    document.cookie=c_name + "=" + c_value;
    }

    this.getFromClientStorage = function(storage_name, cookie_name)
    {
    cookie_name = this.validateArgument(cookie_name, storage_name)
    if (window.localStorage.getItem(storage_name))
    {
        return window.localStorage.getItem(storage_name)
    }
    else if (this.checkCookie(cookie_name))
    {
        return this.checkCookie(cookie_name)
    }
    else
    {
        return null;
    }
    }
    

    this.checkCookie = function(c_name)
    {
    var c_value = this.getCookie(c_name);
    if (c_value != null && c_value != "")
    {
        return c_value;
    }
    else
    {
        return null;
    }
    }

    this.getParameterByName = function(name, url) {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
};

var utils = new TTUtils()

var parseCart = function(cart){
  var items_map = {
    'token' : cart['token'],
    'items' : {}
  }
  for(item_key in cart['items']){
    item = cart['items'][item_key]
    items_map['items'][item['product_id']] = item['quantity']
  }
  return items_map
}

var removeFromCart= function(token,object_id, quantity){
  var cart_event = {
    'object_type' : 'product',
    'action_type' : 'remove_from_cart',
    'object_id' : object_id,
    'user_type' : 'guest',
    'cart_token' : token,
    'platform' : 'shopify'
  }
  if(yfret_customer['email'] != null){
    cart_event['user_type'] = 'email',
    cart_event['user_id'] = yfret_customer['email']
  }

  if(window.localStorage.getItem('cem.subscriptionId')){
    cart_event['browser_endpoint'] = window.localStorage.getItem('cem.subscriptionId')
  }
  
  for(var i=0;i<quantity;i++){
    //console.log('remove from cart event')
    utils.post(cart_event, true, false)
  }  
}

var addToCart = function(token,object_id, quantity){
  var cart_event = {
    'object_type' : 'product',
    'action_type' : 'add_to_cart',
    'object_id' : object_id,
    'user_type' : 'guest',
    'cart_token' : token,
    'platform' : 'shopify'
  }
  if(yfret_customer['email'] != null){
    cart_event['user_type'] = 'email',
    cart_event['user_id'] = yfret_customer['email']
  }

  if(window.localStorage.getItem('cem.subscriptionId')){
    cart_event['browser_endpoint'] = window.localStorage.getItem('cem.subscriptionId')
  }
  
  for(var i=0;i<quantity;i++){
    //console.log('add to cart event')
    utils.post(cart_event, true, false)
  }  
}

var checkCartUpdates = function(cart_details,new_cart_details){
  var update_flag = false
  var token = new_cart_details['token']
  var cart = cart_details['items']
  var new_cart = new_cart_details['items']
  
  //check product remove
  for(product_id in cart){
    if(product_id in new_cart){
      if(cart[product_id] > new_cart[product_id]){
        removeFromCart(token,product_id,cart[product_id] - new_cart['product_id'])
        update_flag = true
      }
    }
    else{
      removeFromCart(token, product_id,cart[product_id])
      update_flag = true
    }
  }
  
  //check product add
  for(product_id in new_cart){
    if(product_id in cart){
      if(new_cart[product_id] > cart[product_id]){
        addToCart(token, product_id, new_cart[product_id] - cart[product_id])
        update_flag = true
      }
    }
    else{
      addToCart(token, product_id, new_cart[product_id])
      update_flag = true
    }
  }
  
  return update_flag
}

//should send cart_id, customer_id, product_ids
var sendCartUpdate = function() {
    //console.log('send cart update called')
    setTimeout(function (){
      Shopify.getCart(function(cart){
        //console.log(cart,'latest_cart')
        var existing_cart = JSON.parse(window.sessionStorage['yfret_cart'])
        var new_cart = parseCart(cart)
        if(checkCartUpdates(existing_cart, new_cart)){
           window.sessionStorage['yfret_cart'] = JSON.stringify(new_cart)
        }
      })
    },5000)
}

var sendCollectionViewEvent = function(object_id) {
    var collection_event = {
        'object_type': 'collection',
        'action_type': 'view',
        'platform': 'shopify',
        'object_id': object_id,
    }
    if(yfret_customer['email'] == null){
        collection_event['user_type'] = 'guest'
    } else {
        collection_event['user_type'] = 'email'
        collection_event['user_id'] = yfret_customer['email']
    }

    if(window.localStorage.getItem('cem.subscriptionId')){
        collection_event['browser_endpoint'] = window.localStorage.getItem('cem.subscriptionId')
    }

    utils.post(collection_event, true, false)

}

//should send product_id, tt_id, s_id, customer_id
var sendProductViewEvent = function() {  
  var product_event = {
    'object_type' : 'product',
    'action_type' : 'view',
    'platform' : 'shopify',
    'object_id' : yfret_product['id'],
  }
  if(yfret_customer['email'] == null){
    product_event['user_type'] = 'guest'
  } else {
    product_event['user_type'] = 'email'
    product_event['user_id'] = yfret_customer['email']
  }

  if(window.localStorage.getItem('cem.subscriptionId')){
    product_event['browser_endpoint'] = window.localStorage.getItem('cem.subscriptionId')
  }

  utils.post(product_event, true, false)
}

var notifyAction = function(action) {
    var event = {
        'action_type': action['action_type'],
        'platform': 'shopify',
    }

    if(yfret_customer['email'] == null){
        event['user_type'] = 'guest'
    } else {
        event['user_type'] = 'email'
        event['user_id'] = yfret_customer['email']
    }

    if(window.localStorage.getItem('cem.subscriptionId')){
        event['browser_endpoint'] = window.localStorage.getItem('cem.subscriptionId')
    }

    utils.post(event, true, false)
}


if (window.location.pathname.indexOf('/products/') !== -1) {
    sendProductViewEvent()
    //console.log('product view event sent')
} else if (window.location.pathname.indexOf('/collections/') !== -1){
    if(yfret_collection && yfret_collection['name']){
        sendCollectionViewEvent(yfret_collection['name'])
    }
} else if (window.location.pathname.indexOf('/pages/') !== -1){
    if(yfret_page && yfret_page['name']){
        sendCollectionViewEvent(yfret_page['name'])
    }
} else if(utils.getParameterByName("yfret_source") ||
        utils.getParameterByName("yfret_campaign") ||
        utils.getParameterByName("yfret_medium") ||
        utils.getParameterByName("utm_source") ||
        utils.getParameterByName("utm_campaign") ||
        utils.getParameterByName("utm_medium")){
            notifyAction({"action_type":"track_session"})
} else if((!utils.getCookie('tt_sid')) && (!window.sessionStorage.getItem('tt_sid'))){
    notifyAction({"action_type":"track_session"})
} 



//console.log("yfret script")

setTimeout(function() {
  Shopify.getCart(function(cart){
  //console.log('on page load')
  if(document.referrer == 'https://checkout.shopify.com/' && cart['item_count']==0){
    new_cart = parseCart(cart)
    window.sessionStorage['yfret_cart'] = JSON.stringify(new_cart)
    //console.log("order placed cart empty")
  }
  else if('yfret_cart' in window.sessionStorage){
    existing_cart = JSON.parse(window.sessionStorage['yfret_cart'])
    new_cart = parseCart(cart)
    if(checkCartUpdates(existing_cart, new_cart)){
       window.sessionStorage['yfret_cart'] = JSON.stringify(new_cart)
    }
    else{
       //console.log('cart remains the same')
    }   
  }
  else{
    new_cart = parseCart(cart)
    window.sessionStorage['yfret_cart'] = JSON.stringify(new_cart)
    //console.log('intial load cart update not sent')
    //sendCartUpdate(cart)
  }
})
},3000)
